import { POST } from '@/api'

/**
 * トークン
 */
export default {
  namespaced: true,
  actions: {
    async get(store, path) {
      const requestPath = path.path || path
      const { status, message, data } = await POST('/api/web/token/get', {
        path: requestPath.replace(/^\//, ''),
        parameter: path.parameter,
      })
      if (status !== 200) store.commit('app/error', { status, message }, { root: true })
      return data.token
    },
  },
}
